import React from 'react';
import { Link } from 'react-router-dom';

const CTA = () => (
    <div className="relative py-14 bg-gray-100 overflow-hidden text-black">
        <div className="absolute inset-0 opacity-5">
            <div className="w-full h-full" style={{
                backgroundImage: `radial-gradient(circle at 30px 30px, black 2px, transparent 2px)`,
                backgroundSize: '60px 60px'
            }}></div>
        </div>
        
        <div className="relative z-10 text-center max-w-4xl mx-auto px-6">
            <h2 className="text-2xl md:text-3xl font-thin tracking-tight leading-none mb-6 text-black">
                READY TO TRANSFORM?
            </h2>
            <p className="text-lg font-light leading-relaxed max-w-2xl mx-auto tracking-wide text-gray-800 mb-8">
                Join leading organizations leveraging AI for competitive advantage
            </p>
            <div className="w-px h-12 bg-gradient-to-b from-transparent via-black to-transparent mx-auto mb-8"></div>
            <Link to={"/contact-us"} className="inline-block border border-black/20 hover:border-black/40 px-8 py-3 text-sm tracking-[0.1em] uppercase font-light text-black hover:bg-black/5 transition-all duration-300">
                Get In Touch
            </Link>
        </div>
    </div>
);

export default CTA;